import { useState, useEffect, useCallback } from "react";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import OwnerAlertsPanel from "../components/owner_alerts/OwnerAlertsPanel";
import OwnerAlertSettings from "../components/owner_alerts/OwnerAlertSettings";

const TABS = [
  { id: "alerts", label: "Alertas" },
  { id: "settings", label: "Configurações" },
];

export default function OwnerAlertsPage() {
  const { authAxios } = useAuth();
  const [tab, setTab] = useState("alerts");
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAlerts = useCallback(async () => {
    setLoading(true);
    try {
      const res = await authAxios.get("/owner-alerts?limit=100");
      setAlerts(res.data?.alerts ?? []);
    } catch {
      toast.error("Erro ao carregar alertas");
    } finally {
      setLoading(false);
    }
  }, [authAxios]);

  useEffect(() => {
    if (tab === "alerts") fetchAlerts();
  }, [tab, fetchAlerts]);

  const handleIgnore = async (alertId) => {
    try {
      await authAxios.post(`/owner-alerts/${alertId}/ignore`);
      setAlerts((prev) =>
        prev.map((a) => (a.id === alertId ? { ...a, status: "ignored" } : a))
      );
    } catch {
      toast.error("Erro ao ignorar alerta");
    }
  };

  const handleResolve = async (alertId) => {
    try {
      await authAxios.post(`/owner-alerts/${alertId}/resolve`);
      setAlerts((prev) =>
        prev.map((a) => (a.id === alertId ? { ...a, status: "resolved" } : a))
      );
      toast.success("Alerta marcado como resolvido");
    } catch {
      toast.error("Erro ao resolver alerta");
    }
  };

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <h1 className="text-xl font-bold text-gray-900 mb-6">Alertas de Performance</h1>

      <div className="flex border-b border-gray-200 mb-6">
        {TABS.map((t) => (
          <button
            key={t.id}
            onClick={() => setTab(t.id)}
            className={`px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px ${
              tab === t.id
                ? "border-blue-600 text-blue-600"
                : "border-transparent text-gray-500 hover:text-gray-700"
            }`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {tab === "alerts" && (
        <OwnerAlertsPanel
          alerts={alerts}
          loading={loading}
          onIgnore={handleIgnore}
          onResolve={handleResolve}
          onRefresh={fetchAlerts}
        />
      )}

      {tab === "settings" && <OwnerAlertSettings />}
    </div>
  );
}
